module.exports = __webpack_public_path__ + "static/media/pic2.3b6fd9b5.jpg";